import { MSL_HOST_CONFIG } from './msl'
import { HOST_NAMES, HostConfig } from './types'
import { GAMBYT_DEMO_HOST_CONFIG } from './gambyt-demo.tsx'

export const hostConfigByName: Record<HOST_NAMES, HostConfig> = {
  [HOST_NAMES.MSL]: MSL_HOST_CONFIG,
  [HOST_NAMES.GAMBYT_DEMO]: GAMBYT_DEMO_HOST_CONFIG,
}

export const ConfigUtils = {}
